<template>
	<div>
		<p class="underline" @click="showFilters">Advance Search</p>
		<div  v-if="openFilterDropdown">
			<div class="arrow-up"></div>
			<img
                src="../assets/cancel.png"
				class="cross"
                width="22px"
                height="22px"
                @click="openFilterDropdown = false"
            />
			<div :style="filterBox">
				<slot></slot>
			</div>
		</div>

	</div>
</template>

<script>
export default {
	name: 'AdvanceFilters',

	props: {
		columnsPerRow: {required: true, type: Number}
	},

	computed: {
		filterBox(){
			return{
				"display": "grid",
				"grid-template-columns": "repeat("+this.columnsPerRow+",1fr)",
				"grid-column-gap": "20px",
				"grid-row-gap": "20px",
				"padding": "2%",
				"box-shadow": "0 0 50px 0 var(--very-light-pink)"
			}
		}
	},

	data(){
		return{
			openFilterDropdown: false
		}
	},

	methods:{
		showFilters(){
			this.openFilterDropdown = !this.openFilterDropdown;
		}
	},

	mounted(){}
}
</script>

<style lang="scss" scoped>
.underline{
  text-decoration: underline;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  width: fit-content;
  margin-bottom: 5px;
}

.arrow-up {
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 18px solid white;
  right: -36px;
  position: relative;
}

.cross {
	position: relative;
    right: 15px;
    top: -8px;
    cursor: pointer;
    float: right;
}
</style>